import { useEffect } from 'react';

import { EventApplicationStart } from './gtm';

type Props = {
    applicationId: any;
    currentPage: number;
    countryCode: string;
};

const EventApplicationStartHelper: React.FC<Props> = ({ applicationId, currentPage, countryCode }) => {
    useEffect(() => {
        EventApplicationStart(applicationId, currentPage, countryCode);
    }, [applicationId, currentPage, countryCode]);

    return null;
};

export default EventApplicationStartHelper;
